let emojiNames = [
    'Motorcykel',
    'Bil',
    'Game pad',
    'Guitar',
    'Ispind',
    'Ninja',
    'Keyboard',
    'Raket',
    'Superhelt'
]

let emojiPronounciation = [
    null,
    null,
    'Game paht',
    null,
    null,
    null,
    null,
    null,
    null,
]

export function getEmojiName(intCode) {
    return intCode < emojiNames.length ? emojiNames[intCode] : intCode;
}

export function getEmojiPronounciation(intCode) {
    return intCode < emojiPronounciation.length && emojiPronounciation[intCode] ? emojiPronounciation[intCode] : getEmojiName(intCode);
}